import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'summary-reports'
const verb = 'get'

export default class OspreyGetMatchedRo extends BaseAction {
    constructor(dataKey, onError) {
        const id = '71030c85-f40c-c053-9c29-8c5ba38539b1'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true

        this.onError = onError
    }

    getMatchedRepairOrders(params) {
        const { programId, ...param } = params

        this.path = `/${resource}/${programId}/matched-repair-orders`
        this.params = {
            ...param
        }

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/summary-reports/get-matched-ro.js